import React from 'react';
import Providers from './src/store/providers';

export const wrapRootElement = ({ element }) => (
  <Providers>{element}</Providers>
);
